import { z } from "zod";
import { redirectUriSchema } from "./create-oauth-client-request";

// Partial update of an OAuth client — NO client_id (it's the route key). Every field is
// .nullable().optional() per the house rule (bare .optional() 400s on an explicit null). Value-based
// semantics, resolved server-side: null/absent ⇒ leave unchanged; [] ⇒ clear an array; a non-empty value
// ⇒ replace. client_secret present ⇒ replace + re-hash. Clearing slug/display_name is out of scope for v1.
export const updateOAuthClientRequestSchema = z.object({
  application_type: z.enum(["web", "native"]).nullable().optional(),
  client_type: z.enum(["public", "confidential"]).nullable().optional(),
  display_name: z.string().max(200, "Too long").nullable().optional(),
  client_secret: z.string().min(1).max(500).nullable().optional(),
  redirect_uris: z.array(redirectUriSchema).nullable().optional(),
  permissions: z.array(z.string()).nullable().optional(),
  slug: z.string().min(1, "slug cannot be blank").max(50, "Too long").regex(/\S/, "slug cannot be blank").nullable().optional(),
});
